import { ParadataEventService } from '@/common/paradata-event/paradata-event.service';
import { DueSurveyDialogData } from '@/surveys/dialogs-data/due-survey-dialog-data';
import { DueSurveyDialogService } from '@/surveys/services/due-survey-dialog.service';
import { RequestExtensionDialogService } from '@/surveys/services/request-extension-dialog.service';
import { ShareSurveyAccessDialogService } from '@/surveys/services/share-survey-access-dialog.service';
import { FilingStatusDialogService } from '@/surveys/services/filing-status-dialog.service';
import { SurveyViewsInstanceService } from '@/surveys/services/survey-views-instance.service';
import { AppSettingsService } from '@/common/services/app-settings.service';
import { EventService } from '@/surveys/services/event.service';
import { Component, Input, OnDestroy, OnInit, inject, signal, computed, DestroyRef } from '@angular/core';
import { Router } from '@angular/router';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatListModule } from '@angular/material/list';
import { MatTabsModule } from '@angular/material/tabs';
import { MatTooltipModule } from '@angular/material/tooltip';
import { DueSurveyDialogComponent } from '@/surveys/dialogs/due-survey-dialog/due-survey-dialog.component';
import { ByPassSecurityModule } from '@/surveys/pipe/by-pass-security/by-pass-security.module';
import { DecodeXmlModule } from '@/surveys/pipe/decode-xml/decode-xml.module';

@Component({
    selector: 'app-calendar-view-instance',
    templateUrl: './calendar-view-instance.component.html',
    standalone: true,
    imports: [
        CommonModule,
        ReactiveFormsModule,
        FormsModule,
        MatInputModule,
        MatTabsModule,
        MatIconModule,
        MatListModule,
        MatButtonModule,
        MatCardModule,
        MatTooltipModule,
        DueSurveyDialogComponent,
        DecodeXmlModule,
        ByPassSecurityModule
    ],
    providers: [
        ParadataEventService,
        DueSurveyDialogService,
        RequestExtensionDialogService,
        ShareSurveyAccessDialogService,
        FilingStatusDialogService,
        SurveyViewsInstanceService,
        EventService
    ]
})
export class CalendarViewInstanceComponent implements OnInit, OnDestroy {
    // Services using inject()
    private destroyRef = inject(DestroyRef);
    private paradataEventService = inject(ParadataEventService);
    private dueSurveyDialogService = inject(DueSurveyDialogService);
    private eventService = inject(EventService);
    public router = inject(Router);

    // Signals for reactive state
    complete = signal<boolean>(true);
    overdue = signal<boolean>(false);
    statusString = signal<string>('');

    // Computed signals
    isComplete = computed(() => this.complete());
    isOverdue = computed(() => this.overdue());
    currentStatusString = computed(() => this.statusString());

    @Input('date')
    date: any;

    @Input('active')
    active: boolean;

    determineStatuses() {
        if (this.date.surveys.length > 0) {
            this.complete.set(true);
            this.overdue.set(false);
            this.statusString.set('complete');
            for (let i = 0; i < this.date.surveys.length; i++) {
                if (this.date.surveys[i].formStatus !== 3) {
                    this.complete.set(false);
                    this.statusString.set('incomplete');
                    if (this.date.surveys[i].formStatus === 1) {
                        this.overdue.set(true);
                        this.statusString.set('overdue');
                    }
                }
            }
        }
    }

    dayHasSurvey() {
        if (this.date.surveys && this.date.surveys.length > 0) {
            return true;
        }
        return false;
    }

    openDueSurveysDialog() {
        const options: DueSurveyDialogData = {
            title: 'SURVEY DUE',
            cancelButtonLabel: 'Close',
            surveys: this.date.surveys || [],
            date: this.date.date,
            active: this.active
        };
        
        this.dueSurveyDialogService.open(options);
    }

    // Function sent to modals from which to emit paradata events. Modals use isolated scopes so any emissions 
    // from them would not be picked up by the ParadataCatcher unless sent from an attached scope like this.
    // Cannot be added to utilityService, despite its widespread use, because services cannot make use of $scope.
    // emitParadataEvent(event, data) {
    // $scope.$emit(event, data);
    // }

    goToCard(orgId: number) {
        this.eventService.emitEvent({
            orgId: orgId
        });
    }

    ngOnInit(): void {
        this.determineStatuses();
    }

    ngOnDestroy() {
        this.paradataEventService.flushParadataevents();
    }

}
